import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Descriptions, Typography, Spin, Result, Tag } from 'antd';
import dayjs from 'dayjs';
import { getPublicNoticeLetterShare } from '../../services/debt';
import './NoticeBatchSharePage.css';

const { Text } = Typography;

const buildDownloadUrl = (token) => {
  if (!token) return '';
  const loc = window.location || {};
  const protocol = loc.protocol || window.location.protocol;
  const hostname = loc.hostname || window.location.hostname;
  const port = loc.port || window.location.port;
  if (port === '3000') {
    return `${protocol}//${hostname}:8080/api/debt/notice/download/${token}`;
  }
  return `/api/debt/notice/download/${token}`;
};

const statusTag = (status) => {
  const v = String(status || '');
  let color = 'default';
  if (v === 'SUCCESS') color = 'green';
  else if (v === 'FAILED') color = 'red';
  else if (v === 'PARTIAL_SUCCESS') color = 'orange';
  else if (v === 'SENDING') color = 'blue';
  return <Tag color={color}>{v || '-'}</Tag>;
};

const NoticeLetterSharePage = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const { data: res } = await getPublicNoticeLetterShare(token);
        setData(res || null);
      } catch (e) {
        setError(e?.message || '加载失败');
      } finally {
        setLoading(false);
      }
    };
    if (token) load();
  }, [token]);

  useEffect(() => {
    if (data?.recipient?.receiverName) {
      document.title = `催告函通知 - ${data.recipient.receiverName}`;
    }
    return () => {
      document.title = '小金蝉';
    };
  }, [data]);

  if (loading) {
    return (
      <div className="page-container p-share-notice-batch">
        <div className="page-content">
          <div className="p-share-notice-batch-loading">
            <Spin />
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-container p-share-notice-batch">
        <div className="page-content">
          <Result status="error" title="无法打开公示页面" subTitle={error} />
        </div>
      </div>
    );
  }

  const recipient = data?.recipient || null;

  return (
    <div className="page-container p-share-notice-batch">
      <div className="page-content space-y-md">
        <div className="space-y-sm">
          <div className="page-title">催告函公示</div>
          {data?.expiresAt ? (
            <div>
              <Text type="secondary">链接有效期至：{dayjs(data.expiresAt).format('YYYY-MM-DD HH:mm')}</Text>
            </div>
          ) : null}
        </div>

      <Card className="card-compact">
        <Descriptions bordered size="small" column={1} title="批次信息">
          <Descriptions.Item label="批次ID">{data?.batchId || '-'}</Descriptions.Item>
          <Descriptions.Item label="状态">{statusTag(data?.status)}</Descriptions.Item>
          <Descriptions.Item label="发送开始时间">{data?.sentAt ? dayjs(data.sentAt).format('YYYY-MM-DD HH:mm') : '-'}</Descriptions.Item>
          <Descriptions.Item label="完成时间">{data?.finishedAt ? dayjs(data.finishedAt).format('YYYY-MM-DD HH:mm') : '-'}</Descriptions.Item>
          <Descriptions.Item label="债权ID">{data?.debtId || '-'}</Descriptions.Item>
        </Descriptions>
      </Card>

      <Card className="card-compact" title="收件人（已脱敏）">
        <Descriptions bordered size="small" column={1}>
          <Descriptions.Item label="类型">{recipient?.debtorType === 'P' ? '个人' : recipient?.debtorType === 'E' ? '企业' : recipient?.debtorType || '-'}</Descriptions.Item>
          <Descriptions.Item label="名称">{recipient?.receiverName || '-'}</Descriptions.Item>
          <Descriptions.Item label="手机号">{recipient?.receiverPhone || '-'}</Descriptions.Item>
          <Descriptions.Item label="邮箱">{recipient?.receiverEmail || '-'}</Descriptions.Item>
          <Descriptions.Item label="状态">{recipient?.status || '-'}</Descriptions.Item>
          <Descriptions.Item label="催告函">
            {recipient?.downloadToken ? (
              <a href={buildDownloadUrl(recipient.downloadToken)} target="_blank" rel="noopener noreferrer">
                查看催告函
              </a>
            ) : '-'}
          </Descriptions.Item>
        </Descriptions>
      </Card>
      </div>
    </div>
  );
};

export default NoticeLetterSharePage;
